<template>
    <section class="flex flex-col gap-4">
        <div class="summary-card">
            <div class="flex items-center gap-2 mb-3">
                <!-- Badges use the LAB-988 palette: cyan for strengths (up arrow),
                     magenta for growth areas (diagonal ↗ arrow). Inlined SVG keeps
                     the exact iconography from the design mocks. -->
                <svg class="badge-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="8" cy="8" r="8" fill="#14c8eb" />
                    <path d="M8 11.5 V4.8 M5.2 7.6 L8 4.6 L10.8 7.6" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="body-small-bold text-valence-stone-900">Strengths</div>
            </div>
            <ul class="flex flex-col gap-2 body-small text-valence-stone-500 leading-snug">
                <li v-for="(s, i) in strengths" :key="`s-${i}`" class="flex gap-2">
                    <span class="dot shrink-0 mt-2"></span>
                    {{ s }}
                </li>
                <li v-if="strengths.length === 0" class="text-valence-stone-500 italic">No clear patterns yet.</li>
            </ul>
        </div>
        <div class="summary-card">
            <div class="flex items-center gap-2 mb-3">
                <svg class="badge-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <circle cx="8" cy="8" r="8" fill="#cd2f7b" />
                    <path d="M5.2 10.8 L10.8 5.2 M6.4 5.2 L10.8 5.2 L10.8 9.6" stroke="#fff" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <div class="body-small-bold text-valence-stone-900">Where there's room to grow</div>
            </div>
            <ul class="flex flex-col gap-2 body-small text-valence-stone-500 leading-snug">
                <li v-for="(g, i) in growthAreas" :key="`g-${i}`" class="flex gap-2">
                    <span class="dot shrink-0 mt-2"></span>
                    {{ g }}
                </li>
                <li v-if="growthAreas.length === 0" class="text-valence-stone-500 italic">No clear patterns yet.</li>
            </ul>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
    summary: { strengths?: string[]; growth_areas?: string[] };
}

const props = defineProps<Props>();

const strengths = computed(() => props.summary.strengths ?? []);
const growthAreas = computed(() => props.summary.growth_areas ?? []);
</script>

<style scoped>
@reference "../../../css/tailwind.css";

@layer components {
    .summary-card {
        @apply bg-white rounded-xl border border-valence-cream-300 p-5;
    }

    .badge-icon {
        @apply w-4 h-4 shrink-0;
    }

    .dot {
        @apply w-1.5 h-1.5 rounded-full bg-current;
    }
}
</style>
